package top.wcpe.allincore.ui.runtime.ir.call

/**
 * 运行期函数引用值（`::name`）。
 *
 * C3 阶段仅承载名字与类型标记；实际调用分派由后续阶段（C4 fun）接管。
 */
data class FunRefValue(val name: String) {

    override fun toString(): String = "FunRef(::$name)"
}
